import {
  createRouter,
  createWebHistory,
  RouteLocationNormalized,
  NavigationGuardNext,
} from "vue-router";
import { useTranslate } from "@/libs/utils";
import integrationsIcon from "@/static/images/integrations.svg";
import billingIcon from "@/static/images/dollar.svg";
import giftIcon from "@/static/images/gift.svg";
import dollar2Icon from "@/static/images/dollar-2.svg";
import creditsIcon from "@/static/images/credits.svg";
import settingsIcon from "@/static/images/settings.svg";
import contactsIcon from "@/static/images/contacts.svg";
import searchIcon from "@/static/images/search.svg";
import membersIcon from "@/static/images/members.svg";
import guideIcon from "@/static/images/guide.svg";
import apiIcon from "@/static/images/linearIcon/api.svg";
import { sentryHistoryConfigureScopeTag } from "@wltech/hooks/src/useSentryConfig";
import { LinkedinContactUrlPerson } from "@/config";
import RouteLoadError from "@/views/web/route-load-error.vue";
const translate = useTranslate();
const DYNAMIC_IMPORT_RELOAD_KEY = "lc_dynamic_import_reload";

const isDynamicImportError = (error: unknown) => {
  const message = error instanceof Error ? error.message : String(error);
  return /(?:dynamically imported module|importing a module script|loading (?:chunk|CSS chunk)|ChunkLoadError)/i.test(
    message,
  );
};
const WebRouterConfig = [
  {
    path: "/",
    name: "",
    component: () => import("@/pages/Main.vue"),
    meta: { title: "首页", icon: "integrations" },
    redirect: "/finder",
    children: [
      {
        path: "/guide",
        name: "Guide",
        component: () => import("@/views/main/guide/index.vue"),
        meta: {
          title: translate("Pc_Menu_Guide"),
          titleI18n: "Pc_Menu_Guide",
          hide: false,
          icon: guideIcon,
        },
      },
      {
        path: "/finder",
        name: "Finder",
        component: () => import("@/views/main/finder/index.vue"),
        meta: {
          title: translate("Pc_Menu_Finder"),
          titleI18n: "Pc_Menu_Finder",
          hide: false,
          icon: searchIcon,
        },
      },
      {
        path: "/contacts",
        name: "Contacts",
        component: () => import("@/views/main/contacts/index.vue"),
        meta: {
          title: translate("Contacts_List_Header_Contacts"),
          titleI18n: "Contacts_List_Header_Contacts",
          hide: false,
          icon: contactsIcon,
        },
      },
      // {
      //   path: "/credits",
      //   name: "Credits",
      //   component: () => import("@/views/main/credits/index.vue"),
      //   meta: { title: translate("credits_for_prospect_sync", [""]), titleI18n: "credits_for_prospect_sync", hide: false, icon: creditsIcon },
      // },
      {
        path: "/leads-details",
        name: "LeadsDetails",
        component: () => import("@/views/main/credits/LeadsDetails.vue"),
        meta: {
          title: translate("credits_for_prospect_sync", [""]),
          titleI18n: "credits_for_prospect_sync",
          hide: true,
          icon: creditsIcon,
        },
      },
      {
        path: "/account",
        name: "Account",
        component: () => import("@/views/main/account/indexNew.vue"),
        meta: {
          title: translate("Plan_Navigation"),
          titleI18n: "Plan_Navigation",
          hide: false,
          icon: billingIcon,
        },
        children: [
          {
            path: "change-plan",
            name: "AccountChangePlan",
            component: () => import("@/views/main/account/B/index.vue"),
            meta: {
              title: translate("Plan_Navigation"),
              titleI18n: "Plan_Navigation",
              hide: true,
              icon: billingIcon,
            },
          },
        ],
      },
      {
        path: "/subscription",
        name: "Subscription",
        component: () => import("@/views/main/account/indexNew.vue"),
        meta: {
          title: translate("Subscription"),
          titleI18n: "Subscription",
          hide: true,
          icon: giftIcon,
        },
      },
      {
        path: "/reward",
        name: "Reward",
        component: () => import("@/views/main/reward/index.vue"),
        meta: {
          title: translate("reward"),
          titleI18n: "reward",
          hide: false,
          icon: giftIcon,
        },
      },
      {
        path: "/api",
        name: "Api",
        component: () => import("@/views/main/api/index.vue"),
        meta: {
          title: "API",
          titleI18n: "API",
          hide: false,
          icon: apiIcon,
        },
      },
      {
        path: "/affiliate",
        name: "Affiliate",
        redirect: "/reward",
        meta: {
          title: translate("Affiliate_Lefttab"),
          titleI18n: "Affiliate_Lefttab",
          hide: true,
          icon: dollar2Icon,
        },
      },
      // {
      //   path: "/reward-india",
      //   name: "RewardIndia",
      //   redirect: "/affiliate",
      //   meta: { title: translate("Affiliate_Lefttab"), titleI18n: "Affiliate_Lefttab", hide: true },
      // },
      {
        path: "/members",
        name: "Members",
        component: () => import("@/views/main/members/index.vue"),
        meta: {
          title: translate("member"),
          titleI18n: "member",
          hide: false,
          icon: membersIcon,
        },
      },
      // {
      //   path: "/google-ads",
      //   name: "GoogleAds",
      //   component: () => import("@/views/googleAds/index.vue"),
      //   meta: { title: "GoogleAds test", hide: false, icon: billingIcon },
      // },
      {
        path: "/settings",
        name: "Settings",
        component: () => import("@/views/main/settings/index.vue"),
        redirect: "/settings/integrations",
        meta: {
          title: translate("settings"),
          titleI18n: "settings",
          hide: true,
          icon: settingsIcon,
        },
        children: [
          {
            path: "/settings/integrations",
            name: "Integrations",
            component: () => import("@/views/main/integrations/index.vue"),
            meta: {
              title: translate("integrations"),
              titleI18n: "integrations",
              hide: false,
              icon: integrationsIcon,
            },
          },
          // {
          //   path: "/settings/floatingBall",
          //   name: "FloatingBall",
          //   component: () =>
          //     import("@/views/main/settings/floatingBall/index.vue"),
          //   meta: {
          //     title: translate("floating_ball"),
          //     titleI18n: "floating_ball",
          //     hide: false,
          //   },
          // },
          // {
          //   path: "/settings/linkedinCard",
          //   name: "LinkedinCard",
          //   component: () => import("@/views/main/settings/linkedinCard/index.vue"),
          //   meta: { title: translate("linkedin_card"), titleI18n: "linkedin_card", hide: true },
          // },
          // {
          //   path: "/settings/searchEnhancement",
          //   name: "SearchEnhancement",
          //   component: () =>
          //     import("@/views/main/settings/searchEnhancement/index.vue"),
          //   meta: {
          //     title:
          //       translate("Sidebar_Search_Enhancement_Settings") ||
          //       "Search Enhancement",
          //     titleI18n: "Sidebar_Search_Enhancement_Settings",
          //     hide: false,
          //   },
          // },
        ],
      },
    ],
  },
  // {
  //   path: "/google-login",
  //   name: "GoogleLogin",
  //   component: () => import("@/views/main/login/GoogleLogin.vue"),
  //   meta: { title: "谷歌登录", hide: true },
  // },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/main/login/index.vue"),
    meta: { title: "登录", hide: true },
  },
  {
    path: "/login/admin",
    name: "AdminLogin",
    component: () => import("@/views/main/login/AdminLogin.vue"),
    meta: { title: "管理员登录", hide: true },
  },
  {
    path: "/bind-email",
    name: "BindEmail",
    component: () => import("@/views/main/login/index.vue"),
    meta: { title: "绑定邮箱", hide: true },
  },
  {
    path: "/start-page",
    name: "StartPage",
    component: () => import("@/views/main/startPage/index.vue"),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext,
    ) => {
      window.location.replace(LinkedinContactUrlPerson);
      next(false);
    },
    meta: { title: "登录开始页", hide: true },
  },
  {
    path: "/uninstall",
    name: "Uninstall",
    component: () => import("@/views/web/uninstall.vue"),
    meta: { title: "卸载", hide: true },
  },
  {
    path: "/i18n",
    name: "I18n",
    component: () => import("@/views/web/login/i18n.vue"),
    meta: { title: "i18n", hide: true },
  },
  {
    path: "/search-company",
    name: "SerachCompany",
    component: () => import("@/components/LeadContact.vue"),
    meta: { title: "Search Company", hide: true },
  },
  {
    path: "/special-offers",
    name: "SpecialOffers",
    component: () => import("@/views/main/special-offers/index.vue"),
    meta: { title: "Special Offers", hide: true },
  },
  {
    path: "/chatgpt-auth",
    name: "ChatGPTAuth",
    component: () => import("@/views/web/chatgpt-auth.vue"),
    meta: { title: "ChatGPT 授权", hide: true },
  },
  {
    path: "/route-load-error",
    name: "RouteLoadError",
    component: RouteLoadError,
    meta: { title: "Load error", hide: true },
  },
];

export const webRouter = createRouter({
  history: createWebHistory(),
  routes: WebRouterConfig,
});

webRouter.afterEach((_to, _from, failure) => {
  if (!failure) {
    try {
      sessionStorage.removeItem(DYNAMIC_IMPORT_RELOAD_KEY);
    } catch {
      // Ignore storage failures.
    }
  }
  sentryHistoryConfigureScopeTag();
});

webRouter.onError((error, to) => {
  if (!isDynamicImportError(error)) {
    return;
  }

  try {
    if (!sessionStorage.getItem(DYNAMIC_IMPORT_RELOAD_KEY)) {
      sessionStorage.setItem(DYNAMIC_IMPORT_RELOAD_KEY, "1");
      window.location.reload();
      return;
    }
  } catch {
    // Fall through to the visible error route when storage is unavailable.
  }

  webRouter
    .replace({
      name: "RouteLoadError",
      query: { from: to.fullPath },
    })
    .catch(() => undefined);
});
